import PropTypes from 'prop-types';
import React from 'react';

import Copy from '../../atoms/copy/copy';
import Headline from '../../atoms/headline/headline';
import Image from '../../atoms/image/image';
import Link from '../../atoms/link/link';
import StyledContactList from './contactList.style';

import PhoneIcon from '../../icons/phone.svg';
import EmailLink from '../emailLink/emailLink';

const ContactList = props => {
  const { headline, subline, person = [], insideAccordion = false } = props;
  return (
    <StyledContactList {...props} insideAccordion={insideAccordion}>
      {subline && !insideAccordion && (
        <Headline tag="h3" subline>
          {subline}
        </Headline>
      )}
      {headline && !insideAccordion && <Headline secondary>{headline}</Headline>}

      {person && (
        <ul className="contactList__list">
          {person.map(entry => (
            <li
              className={`contactList__person ${
                entry.contactImage ? 'contactList__person--hasImage' : ''
              }`}
              key={entry.id}
            >
              <div className="contactList__headline">
                <Headline tag="h3" tertiary>
                  {entry.fullName}
                </Headline>
                {entry.jobTitle && (
                  <Headline tag="p" subline>
                    {entry.jobTitle}
                  </Headline>
                )}
              </div>

              <div className="contactList__contact">
                {entry.phone && (
                  <Link href={`tel:${entry.phone}`}>
                    <PhoneIcon width="33" height="33" />
                    <Copy tag="span" thick>
                      {entry.phone}
                    </Copy>
                  </Link>
                )}
                {entry.email && <EmailLink encodedEmail={entry.email} />}
              </div>
              {entry.contactImage && (
                <div className="contactList__image">
                  <div className="contactList__image-wrapper">
                    <Image
                      {...entry.contactImage}
                      lazy="default"
                      sizes={[
                        {
                          width: '220px'
                        }
                      ]}
                    />
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </StyledContactList>
  );
};

ContactList.propTypes = {
  headline: PropTypes.string,
  subline: PropTypes.string,
  insideAccordion: PropTypes.bool,
  person: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      contactImage: PropTypes.shape(),
      fullName: PropTypes.string.isRequired,
      jobTitle: PropTypes.string,
      email: PropTypes.string.isRequired,
      phone: PropTypes.string
    })
  )
};

export default ContactList;
